import { DistriApiService } from './distri.api.service';
import { Injectable } from '@angular/core';
// import { Reference } from '@angular/compiler/src/render3/r3_ast';

@Injectable({
  providedIn: 'root'
})
export class DistriCommandeService {
  canValidButton = false;
  constructor(private api: DistriApiService) { }


  generateFacture(id: any) {
    return this.api.get("/common/commandes/generate-facture?id="+id);    
  }

  uploadDistributeurs(form : FormData) {
    return this.api.post("/common/importations/new-distributeurs",form); 
  }
  findLoadDataTmps(login: string) {
    return this.api.get("/common/importations/search/load-data?login="+login);    
  } 
  saveUploadDistributeurs(obj : any[]) {
    return this.api.post("/common/importations/op/save-import-distributeurs", obj); 
  }

  save(commande: any) {
    return this.api.post('/common/commandes', commande);
  }

  sendToOpenStack(file: File, i: number) {
    let formdata = new FormData();
    formdata.append('file', file);
    console.log(formdata);
    return this.api.post('/common/commandes/openstack?index=' + i, formdata);
  }

  commandes() {
    return this.api.get('/common/commandes');
  }

  commandeByRoleAndEtat(target: any, state: any) {
    console.log('state::::::::::::::::::::::', state);
    if (state === 'ENCOURS') {
      this.canValidButton = true;
    }
    return this.api.get('/common/commandes/target/' + target + '?state=' + state);
  }

  getCommandeByCriteria(op: any) {
    return this.api.post('/common/commandes/search', op);
  }

  getCommandeDetailsByCriteria(op: any) {
    return this.api.post('/common/commandes/search-details', op);
  }

  
  getCommandePaginate(page: any, size: any, criteria: any) {
    return this.api.get('/common/commandes/search?typeCommande='
    + criteria.typeCommande + '&dateDebut=' + criteria.dateDebut
    + '&dateFin=' + criteria.dateFin + '&pdg=' + criteria.pdg + '&etat=' + criteria.etat + '&page=' + page + '&size=' + size);
  }


  commandeByLoginAndEtat(target: any, state?: any) {
    return this.api.get('/common/commandes/login/' + target + '?state=' + state);
  }

  getOracleData(reference: any) {
    return this.api.get('/common/commandes/oracle/' + reference);
  }

  getProduit() {
    return this.api.get('/common/commandes/produits');
  }

  commande(id: any) {
    return this.api.get('/common/commandes/' + id);
  }

  // commandeByIdAndTarget(id: any, target: any) {
  //   return this.api.get('/common/commandes/' + id + '/' + target);
  // }

  next(id: any, metaData: any) {
    return this.api.post('/common/commandes/validateCommande/' + id, metaData);
  }

  update(id: any, metaData: any) {
    return this.api.post('/common/commandes/updateCommande/' + id, metaData);
  }

  previous(id: any, metaData: any) {
    console.log('metaData: ', metaData);
    return this.api.post('/common/commandes/rejetCommande/' + id, metaData);
  }

  chechBorderau(reference: any, montant: any, banque: any) {
    return this.api.get('/common/commandes/checkBorderau?reference=' + reference + '&montant='+montant + '&banque=' + banque);
  }
  chechBorderauMode(reference: any, montant: any, mode: any) {
    return this.api.get('/common/commandes/checkBorderauMode?reference=' + reference + '&montant='+montant + '&mode=' + mode);
  }
  chechBorderauRef(reference: any) {
    return this.api.get('/common/commandes/checkBorderauRef?reference=' + reference );
  }

  saveDetail(id: any, idDepot: any) {
    return this.api.get('/common/commandes/saveDetail?id=' + id + '&idDepot=' + idDepot);
  }

  saveDetailSerie(id: any, debut: any, fin:any, series:any) {
    return this.api.get('/common/commandes/saveDetailSerie?id=' + id + '&debut=' + debut+'&fin='+fin+"&series="+series);
  }

  

}
